export enum DataType {
    Unknown = 0,
    Dispute = 1,
    Invoice = 2,
    Payment = 3,
    CustomerDeduction = 4,
    DotBillback = 5,
    CustomerDedRepay = 6,
    Credit = 7
}